module.exports = __webpack_public_path__ + "static/media/companyLogo7.3d2efefb.png";